<lib-coordonnees-bancaires [configuration]="configuration" [fileNamePattern]="fileNamePattern"></lib-coordonnees-bancaires>